import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';

export function sanitizeAddress(address) {
  const clientAddressKeys = [
    'line1',
    'line2',
    'city',
    'region',
    'country',
    'postal',
  ];
  return pickBy(
    address,
    (val, key) => clientAddressKeys.indexOf(key) > -1 && !isEmpty(val)
  );
}

export function sanitizeClientPerson(person) {
  const clientPersonKeys = [
    'address',
    'company_name',
    'first_name',
    'last_name',
    'id',
    'email',
    'dob',
    'phone_number',
    'client_type',
  ];
  const sanitizedPerson = pickBy(
    person,
    (val, key) => clientPersonKeys.indexOf(key) > -1 && !isEmpty(val)
  );
  if (sanitizedPerson.address) {
    sanitizedPerson.address = sanitizeAddress(sanitizedPerson.address);
  }
  return sanitizedPerson;
}

export function sanitizeHolders(holders) {
  const holderKeys = [
    'address',
    'email',
    'first_name',
    'last_name',
    'dob',
    'phone_number',
    'position_on_policy',
    'business_name',
    'title_at_business',
  ];
  return holders.map((holder) => {
    const holderCopy = pickBy(
      holder,
      (val, key) => holderKeys.indexOf(key) > -1 && val !== ''
    );
    holderCopy.address = sanitizeAddress(holderCopy.address);
    return holderCopy;
  });
}

export function sanitizeBeneficiaries(beneficiaries) {
  const beneficiaryKeys = [
    'address',
    'email',
    'first_name',
    'last_name',
    'percentage',
    'phone_number',
    'relationship_description',
  ];
  return beneficiaries.map((beneficiary) => {
    const beneficiaryCopy = pickBy(
      beneficiary,
      (val, key) => beneficiaryKeys.indexOf(key) > -1 && val !== ''
    );
    beneficiaryCopy.address = sanitizeAddress(beneficiaryCopy.address);
    return beneficiaryCopy;
  });
}
